<template>
  <div class="main-root">
    <HeroVideo />
    

    <!-- 關於長發 -->
    <section id="about" class="container-fluid px-0 about-section">
        <div class="row align-items-start about-row">
            <!-- 左側標題欄 -->
            <div class="about-title-col">
                <h2 class="about-title-vertical" style="margin-top:3rem;">關於長發地產｜北台灣高端土地整合專家</h2>
            </div>
            <!-- 右側圖片與說明欄 -->
            <div class="about-img-col">
                <div class="about-img-wrap" style="position:relative;">
                    <img :src="aboutImages[aboutIndex].img" :alt="aboutIndex === 0 ? '長發地產外觀 - 桃園土地開發專家' : '長發地產入口 - 北台灣重劃區整合專家'" class="about-img" loading="lazy" />
                    <!-- 左下角切換按鈕 -->
                    <div class="about-img-btns">
                        <button v-for="(item, idx) in aboutImages"
                                :key="item.img"
                                :class="['about-img-btn', {active: aboutIndex===idx, black: idx===0, gray: idx===1}]"
                                @click="aboutIndex=idx"
                                :aria-label="'切換圖片'+(idx+1)"></button>
                    </div>
                </div>
                <div class="about-desc about-desc-align">{{aboutImages[aboutIndex].desc}}</div>
            </div>
        </div>
    </section>

    <!-- 在地深耕 -->
    <section id="local" class="bg-light">
        <div class="container-fluid px-0">
            <div class="local-area-img-wrap mb-3">
                <div class="local-area-img" :style="localAreaImgStyle">
                    <div class="local-area-titles-overlay">
                        <div v-for="(item, idx) in localAreas" :key="item.title"
                             class="local-area-title-overlay"
                             :class="{active: localAreaHover===idx}"
                             @mouseenter="handleMouseEnter(idx)"
                             @mouseleave="handleMouseLeave()"
                             @click="goToArea(item.link)"
                             :style="getTitleOverlayStyle(idx)">
                            <div class="overlay-mask">
                                <div class="local-area-title-text" :class="{'metro-green-title': idx === 1}">{{item.title}}</div>
                                <div class="local-area-desc">{{item.desc}}</div>
                            </div>
                            <!-- 右下角了解更多小黑格 -->
                            <div class="more-info-box" v-if="localAreaHover===idx">
                                <span class="more-info-text">了解更多</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- 地產小學堂 -->
    <section id="lesson" class="container-fluid px-0 lesson-section-new">
      <div class="row align-items-start lesson-row">
        <!-- 左側標題欄 -->
        <div class="lesson-title-col">
          <h2 class="lesson-title-vertical" style="margin-top:3rem;">地產小學堂</h2>
        </div>
        <!-- 右側內容欄 -->
        <div class="lesson-content-col">
          <div class="lesson-container-new">
            <div class="lesson-tabs mb-4">
              <button 
                v-for="tab in lessonTabs" 
                :key="tab.id"
                :class="['lesson-tab-btn', { active: activeTab === tab.id }]"
                @click="activeTab = tab.id"
              >
                {{ tab.name }}
              </button>
            </div>
            
            <div class="lesson-articles">
              <router-link
                v-for="article in filteredArticles" 
                :key="article.id"
                :to="`/post/${article.slug}`"
                class="lesson-article-card"
              >
                <div class="article-thumbnail" :style="article.thumbnail ? { backgroundImage: `url(${article.thumbnail})` } : {}"></div>
                <div class="article-content">
                  <h3 class="article-title">{{ article.title }}</h3>
                  <p class="article-excerpt">{{ article.excerpt }}</p>
                  <div class="article-date">{{ article.date }}</div>
                </div>
              </router-link>
            </div>
            
            <div class="text-center mt-5">
              <router-link to="/lesson" class="btn-more-articles">更多地產好文章</router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 洽詢表單 -->
    <section id="contact" class="container-fluid px-0 inquiry-section-new">
      <div class="row align-items-start inquiry-row">
        <!-- 左側標題欄 -->
        <div class="inquiry-title-col">
          <h2 class="inquiry-title-vertical" style="margin-top:3rem;">聯絡我們</h2>
        </div>
        
        <!-- 右側表單欄 -->
        <div class="inquiry-form-col">
          <div class="form-container-new">
            <p class="form-subtitle-new mb-5">歡迎填寫以下表單，我們將盡快與您聯繫</p>
            
            <form @submit.prevent="handleSubmit" class="contact-form-home" role="form" aria-label="聯絡諮詢表單">
            <!-- 個人基本資料 -->
            <fieldset class="form-section">
              <legend class="section-title-form">個人基本資料</legend>
              
              <div class="row">
                <div class="col-md-6 mb-4">
                  <label for="name" class="form-label">姓名 <span class="required" aria-label="必填">*</span></label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="name"
                    name="name"
                    v-model="formData.name"
                    :class="{ 'is-invalid': submitted && !formData.name }"
                    placeholder="請輸入您的姓名"
                    autocomplete="name"
                    aria-required="true"
                    aria-describedby="name-error"
                    required
                  />
                  <div id="name-error" class="invalid-feedback" role="alert">請輸入姓名</div>
                </div>
                
                <div class="col-md-6 mb-4">
                  <label for="nickname" class="form-label">暱稱</label>
                  <input 
                    type="text" 
                    class="form-control" 
                    id="nickname"
                    name="nickname"
                    v-model="formData.nickname"
                    placeholder="您希望我們如何稱呼您"
                    autocomplete="nickname"
                  />
                </div>
              </div>
              
              <div class="row">
                <div class="col-md-6 mb-4">
                  <label for="phone" class="form-label">聯絡電話 <span class="required" aria-label="必填">*</span></label>
                  <input 
                    type="tel" 
                    class="form-control" 
                    id="phone"
                    name="phone"
                    v-model="formData.phone"
                    :class="{ 'is-invalid': submitted && !formData.phone }"
                    placeholder="例：0912-345-678"
                    autocomplete="tel"
                    aria-required="true"
                    aria-describedby="phone-error"
                    pattern="[0-9\-]+"
                    required
                  />
                  <div id="phone-error" class="invalid-feedback" role="alert">請輸入聯絡電話</div>
                </div>
                
                <div class="col-md-6 mb-4">
                  <label for="email" class="form-label">電子郵件 <span class="required" aria-label="必填">*</span></label>
                  <input 
                    type="email" 
                    class="form-control" 
                    id="email"
                    name="email"
                    v-model="formData.email"
                    :class="{ 'is-invalid': submitted && !formData.email }"
                    placeholder="example@email.com"
                    autocomplete="email"
                    aria-required="true"
                    aria-describedby="email-error"
                    required
                  />
                  <div id="email-error" class="invalid-feedback" role="alert">請輸入有效的電子郵件</div>
                </div>
              </div>
            </fieldset>
            
            <!-- 洽談事項 -->
            <fieldset class="form-section">
              <legend class="section-title-form">洽談事項</legend>
              
              <div class="mb-4">
                <label for="inquiryType" class="form-label">諮詢類型 <span class="required" aria-label="必填">*</span></label>
                <select 
                  class="form-select" 
                  id="inquiryType"
                  name="inquiryType"
                  v-model="formData.inquiryType"
                  :class="{ 'is-invalid': submitted && !formData.inquiryType }"
                  aria-required="true"
                  aria-describedby="inquiryType-error"
                  required
                >
                  <option value="" disabled>請選擇諮詢類型</option>
                  <option value="土地買賣">土地買賣</option>
                  <option value="重劃整合">重劃整合</option>
                  <option value="區段徵收">區段徵收</option>
                  <option value="合建開發">合建開發</option>
                  <option value="投資諮詢">投資諮詢</option>
                  <option value="我要應徵">我要應徵</option>
                  <option value="其他">其他</option>
                </select>
                <div id="inquiryType-error" class="invalid-feedback" role="alert">請選擇諮詢類型</div>
              </div>
              
              <div class="mb-4">
                <label for="location" class="form-label">土地位置/區域</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="location" 
                  v-model="formData.location"
                  placeholder="例：桃園航空城、捷運綠線沿線"
                />
              </div>
              
              <div class="mb-4">
                <label for="message" class="form-label">詳細說明 <span class="required" aria-label="必填">*</span></label>
                <textarea 
                  class="form-control" 
                  id="message"
                  name="message"
                  v-model="formData.message"
                  :class="{ 'is-invalid': submitted && !formData.message }"
                  rows="6"
                  placeholder="請詳細說明您的需求或問題..."
                  aria-required="true"
                  aria-describedby="message-error"
                  required
                ></textarea>
                <div id="message-error" class="invalid-feedback" role="alert">請輸入詳細說明</div>
              </div>
              
              <div class="mb-4">
                <label for="preferredContact" class="form-label">偏好聯絡方式</label>
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="preferredContact" 
                    id="contactPhone" 
                    value="電話"
                    v-model="formData.preferredContact"
                  />
                  <label class="form-check-label" for="contactPhone">電話</label>
                </div>
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="preferredContact" 
                    id="contactEmail" 
                    value="電子郵件"
                    v-model="formData.preferredContact"
                  />
                  <label class="form-check-label" for="contactEmail">電子郵件</label>
                </div>
                <div class="form-check">
                  <input 
                    class="form-check-input" 
                    type="radio" 
                    name="preferredContact" 
                    id="contactBoth" 
                    value="皆可"
                    v-model="formData.preferredContact"
                    checked
                  />
                  <label class="form-check-label" for="contactBoth">皆可</label>
                </div>
              </div>
              
              <div class="mb-4">
                <label for="preferredTime" class="form-label">方便聯絡時間</label>
                <select class="form-select" id="preferredTime" v-model="formData.preferredTime">
                  <option value="">不指定</option>
                  <option value="上午 (09:00-12:00)">上午 (09:00-12:00)</option>
                  <option value="下午 (13:00-17:00)">下午 (13:00-17:00)</option>
                  <option value="晚上 (18:00-21:00)">晚上 (18:00-21:00)</option>
                </select>
              </div>
            </fieldset>
            
            <!-- 隱私權同意 -->
            <div class="form-section">
              <div class="form-check mb-4">
                <input 
                  class="form-check-input" 
                  type="checkbox" 
                  id="privacyAgree" 
                  v-model="formData.privacyAgree"
                  :class="{ 'is-invalid': submitted && !formData.privacyAgree }"
                  required
                />
                <label class="form-check-label" for="privacyAgree">
                  我已閱讀並同意 <a href="#" class="privacy-link">隱私權政策</a> 及個人資料蒐集使用聲明 <span class="required">*</span>
                </label>
                <div class="invalid-feedback d-block" v-if="submitted && !formData.privacyAgree">
                  請同意隱私權政策
                </div>
              </div>
            </div>
            
            <!-- 提交按鈕 -->
            <div class="text-center mt-5">
              <button 
                type="submit" 
                class="btn btn-submit"
                :disabled="isSubmitting"
              >
                <span v-if="!isSubmitting">送出諮詢</span>
                <span v-else>
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  送出中...
                </span>
              </button>
            </div>
          </form>
          
          <!-- 成功訊息 -->
          <div v-if="submitSuccess" class="alert alert-success mt-4 success-message" role="alert">
            <h5 class="alert-heading">✓ 送出成功！</h5>
            <p>感謝您的諮詢，我們已收到您的訊息，將盡快與您聯繫。</p>
          </div>
          
          <!-- 錯誤訊息 -->
          <div v-if="submitError" class="alert alert-danger mt-4" role="alert">
            <h5 class="alert-heading">送出失敗</h5>
            <p>{{ submitError }}</p>
            <p class="mb-0">請稍後再試，或直接撥打電話：03-3568268</p>
          </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司資訊與地圖 -->
    <section id="company-info" class="container-fluid px-0 company-info-section-new">
      <div class="row align-items-start company-info-row">
        <!-- 右側標題與資訊欄 -->
        <div class="company-info-title-col">
          <h2 class="company-info-title-vertical" style="margin-top:3rem;">公司資訊</h2>
          
          <div class="company-info-content">
            <ul class="list-unstyled company-info-list-new">
              <li><i class="bi bi-geo-alt-fill me-2"></i>地址：桃園市桃園區經國一路92號3樓</li>
              <li><i class="bi bi-telephone-fill me-2"></i>電話：03-3568268</li>
              <li><i class="bi bi-printer-fill me-2"></i>傳真：03-3567286</li>
              <li><i class="bi bi-building me-2"></i>統一編號：60720160</li>
            </ul>
            
            <!-- Facebook 連結 -->
            <div class="facebook-link-container">
              <a href="https://www.facebook.com/profile.php?id=61577068453020" target="_blank" rel="noopener noreferrer" class="facebook-link">
                <img src="https://static.vecteezy.com/system/resources/previews/018/930/698/non_2x/facebook-logo-facebook-icon-transparent-free-png.png" alt="Facebook Logo" class="facebook-icon">
                <span class="facebook-text">長發地產Facebook專頁</span>
              </a>
            </div>
          </div>
        </div>
        
        <!-- 左側地圖欄 -->
        <div class="company-map-col">
          <div class="map-container-new">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.589872684275!2d121.30671287595162!3d25.01220147798089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3468183926e68d8f%3A0x9c9c95b1b8e8e8e8!2z5qGD5ZyS5biC5qGD5ZyS5Y2A57aT5ZyL5LiA6LevOTLomZ8z5qiT!5e0!3m2!1szh-TW!2stw!4v1734000000000!5m2!1szh-TW!2stw"
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="bg-dark text-white py-3 mt-4">
      <div class="container text-center">
        <small>© 2025 長發地產 All Rights Reserved.</small>
      </div>
    </footer>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import HeroVideo from './HeroVideo.vue';

export default {
  name: 'KhouseHome',
  components: { HeroVideo },
  setup() {
    // SEO Meta 標籤
    useHead({
      title: '長發地產 | 北台灣高端土地整合專家 - 桃園航空城、捷運綠線、台鐵中路站開發',
      meta: [
        {
          name: 'description',
          content: '長發地產專注北台灣土地開發整合，涵蓋桃園航空城、捷運綠線G12-G14站、台鐵中路站等重劃區。提供專業土地買賣、區段徵收、合建開發、都市更新與危老重建服務。'
        },
        {
          name: 'keywords',
          content: '長發地產,桃園土地開發,航空城計畫,捷運綠線,台鐵中路站,土地整合,區段徵收,合建開發,都市更新,危老重建,重劃區,北台灣地產'
        },
        // Open Graph
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: '長發地產 | 北台灣高端土地整合專家' },
        { property: 'og:description', content: '專注桃園航空城、捷運綠線等重劃區開發，提供土地買賣、區段徵收、合建開發專業服務' },
        { property: 'og:image', content: '/長發外觀.jpg' },
        { property: 'og:url', content: 'https://changfarealestate.com.tw/' },
        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: '長發地產 | 北台灣高端土地整合專家' },
        { name: 'twitter:description', content: '專注桃園航空城、捷運綠線等重劃區開發' },
        { name: 'twitter:image', content: '/長發外觀.jpg' }
      ],
      script: [
        {
          type: 'application/ld+json',
          children: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'RealEstateAgent',
            name: '長發地產',
            description: '北台灣高端土地整合專家，專注桃園航空城、捷運綠線等重劃區開發',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '經國一路92號3樓',
              addressLocality: '桃園區',
              addressRegion: '桃園市',
              postalCode: '330',
              addressCountry: 'TW'
            },
            telephone: '+886-3-3568268',
            faxNumber: '+886-3-3567286',
            areaServed: ['桃園市', '新北市', '台北市', '新竹縣', '新竹市'],
            priceRange: '$$',
            hasOfferCatalog: {
              '@type': 'OfferCatalog',
              name: '服務項目',
              itemListElement: [
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '土地買賣' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '重劃整合' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '區段徵收' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '合建開發' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '都市更新' } },
                { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '危老重建' } }
              ]
            }
          })
        }
      ]
    });
  },
  data() {
    return {
      isSticky: false,
      navHover: false,
      localAreaHover: null,
      autoPlayTimer: null,
      isUserHovering: false,
      localAreas: [
        {
          title: '桃園航空城計畫',
          img: '/桃園航空城.jpg',
          link: 'https://lems.chuanhwa.com.tw/10707h/home.html'
        },
        {
          title: '捷運綠線G12~G14站周邊土地開發計畫',
          img: '/捷運綠線G13.jpg',
          link: 'https://urdb.tycg.gov.tw/News_Content.aspx?n=10682&s=1578540'
        },
        {
          title: '台鐵地下化中路站周邊土地開發計畫',
          img: '/台鐵中路站.jpg',
          link: 'https://urdb.tycg.gov.tw/News_Content.aspx?n=10711&s=1058472'
        }
      ],
      aboutIndex: 0,
      aboutImages: [
        {
          img: '/長發外觀.jpg',
            desc: `長發地產創立於民國114年，由一群深耕土地開發、熟悉重劃與合建整合的資深經理人共同組成。
                    總部設於桃園，服務範圍橫跨北台灣重點重劃區。`
        },
        {
          img: '/長發入口.jpg',
              desc: `我們擁有第一線市場的敏銳度，結合法規解析、建築規劃、資產整合等專業實力，
            為每一筆土地交易找到最大效益與最適解方。
            從農地、建地、工業地，到都市更新、危老合建——
            我們不只是仲介，更是價值的整合推手。`
        }
      ],
      // 地產小學堂
      activeTab: 'all',
      lessonTabs: [
        { id: 'all', name: '全部文章' },
        { id: 'knowledge', name: '知識百科' },
        { id: 'news', name: '新聞總覽' }
      ],
      articles: [
        // 知識百科
        {
          id: 1,
          slug: 'knowledge-1',
          category: '知識百科',
          date: '2024.10.15',
          title: '什麼是區段徵收？',
          excerpt: '政府為了新都市開發建設、舊都市更新或其他開發目的需要，對於一定區域內之土地全部予以徵收，並重新規劃整理。了解區段徵收對土地所有權人的權益影響。',
          thumbnail: '/區段徵收.png'
        },
        {
          id: 2,
          slug: 'knowledge-2',
          category: '知識百科',
          date: '2024.10.10',
          title: '容積率與建蔽率怎麼算？',
          excerpt: '建蔽率是建築物投影面積與基地面積的比率，容積率則是建築物總樓地板面積與基地面積的比率。這兩個指標直接影響土地的開發價值。',
          thumbnail: '/容積率建蔽率.png'
        },
        {
          id: 3,
          slug: 'knowledge-3',
          category: '知識百科',
          date: '2024.10.08',
          title: '都市更新與危老重建差異',
          excerpt: '都市更新需多數所有權人同意，程序較複雜但獎勵較多；危老重建門檻較低，可100%同意即可實施，但獎勵有時效限制。選擇適合的重建方案很重要。',
            thumbnail: '/都市更新危老重建.png'
        },
        {
          id: 4,
          slug: 'knowledge-4',
          category: '知識百科',
          date: '2024.09.25',
          title: '土地使用分區與地目說明',
          excerpt: '土地使用分區分為住宅區、商業區、工業區等，地目則有建地、農地、林地等分類。了解土地分區管制與地目，是土地交易的基礎知識。',
            thumbnail: '/土地使用分區.png'
        },
        {
          id: 5,
          slug: 'knowledge-5',
          category: '知識百科',
          date: '2024.09.18',
          title: '土地增值稅如何計算？',
          excerpt: '土地增值稅是土地所有權移轉時，就土地漲價部分課徵的稅賦。分為一般稅率與自用住宅優惠稅率，善用優惠稅率可大幅節省稅負。',
            thumbnail: '/土地增值稅.png'
        },
        {
          id: 6,
          slug: 'knowledge-6',
          category: '知識百科',
          date: '2024.09.12',
          title: '不動產實價登錄查詢技巧',
          excerpt: '實價登錄提供真實的不動產交易價格資訊，是買賣雙方議價的重要參考。學會查詢與分析實價登錄資料，能幫助您做出更明智的決策。',
            thumbnail: '/實價登錄查詢技巧.png'
        },
        {
          id: 7,
          slug: 'knowledge-7',
          category: '知識百科',
          date: '2024.09.05',
          title: '農地買賣注意事項',
          excerpt: '農地交易有特殊規定，需注意農地農用、毗鄰耕地優先購買權、農民身分認定等問題。了解農地相關法規，避免交易糾紛。',
            thumbnail: '/農地買賣注意事項.png'
        },
        {
          id: 8,
          slug: 'knowledge-8',
          category: '知識百科',
          date: '2024.08.28',
          title: '地上權與所有權的差別',
          excerpt: '地上權是在他人土地上擁有建築物的權利，不同於完整的土地所有權。地上權住宅價格較低，但有使用年限與貸款限制需注意。',
            thumbnail: '/地上權所有權.png'
        },
        {
          id: 9,
          slug: 'knowledge-9',
          category: '知識百科',
          date: '2024.08.20',
          title: '重劃與徵收的區別',
          excerpt: '重劃是透過土地交換分合，改善土地利用；徵收則是政府強制取得私有土地。兩者對地主的權益影響不同，補償方式也有差異。',
            thumbnail: '/重劃與徵收的區別.png'
        },
        // 新聞總覽
        {
          id: 28,
          slug: 'news-18',
          category: '新聞總覽',
          date: '2026.05.27',
          title: '三鶯線延伸八德工程啟動 張善政：123年朝通車目標邁進',
          excerpt: '捷運三鶯線延伸八德計畫基本設計經費160.57億元審議通過，未來與桃園捷運綠線G04大湳站共構銜接，串聯桃園與雙北軌道路網，朝123年通車目標穩步邁進。',
          thumbnail: '/news-18.jpg'
        },
        {
          id: 27,
          slug: 'news-17',
          category: '新聞總覽',
          date: '2026.05.27',
          title: '🚀桃園航空城95公頃產專區｜正式進入「精準招商」階段‼️',
          excerpt: '桃園市政府正式啟動航空城95公頃產專區精準招商規劃，KPMG得標，航空城正式從土地開發階段轉向產業定位規劃期，朝向「3低1高」低碳產業園區方向推進。',
          thumbnail: '/news-17.jpg'
        },
        {
          id: 26,
          slug: 'news-16',
          category: '新聞總覽',
          date: '2026.03.15',
          title: "區段徵收G12、G13、G14 開發案『市都委會第一次審議進度解析』",
          excerpt: '桃園捷運綠線G12、G13、G14車站周邊土地開發案，近期進入市都委會實質審議階段。115年2月25日召開第一次專案小組審議，並產生會議紀錄，審議正式啟動。',
          thumbnail: '/G121314.jpg'
        },
        {
          id: 20,
          slug: 'news-10',
          category: '新聞總覽',
          date: '2025.11.18',
          title: '桃園航空城優先產業專用區 I 基地開發計畫 - 台壽、榮運攜手打造國際級巨蛋與產業城',
          excerpt: '台灣人壽與榮運合作開發桃園航空城優先產業專用區，總投資超過500億元，將打造國際級巨蛋場館、倉儲物流、旅宿及商場，形成18.9公頃複合式產業城。',
          thumbnail: '/news-10.png'
        },
        {
          id: 21,
          slug: 'news-11',
          category: '新聞總覽',
          date: '2025.11.17',
          title: '經國特區好消息！幸福路跨南崁溪「人行跨橋」正式啟動',
          excerpt: '桃園市政府水務局公告「北溪溪幸福路人行跨橋」工程說明會，此跨橋將串連經國特區與南崁溪兩岸，提升居民生活便利性，結合G12捷運站與經國轉運站，強化區域發展優勢。',
          thumbnail: '/news-11.jpg'
        },
        {
          id: 22,
          slug: 'news-12',
          category: '新聞總覽',
          date: '2025.11.14',
          title: '經國特區 × G12 G13 G14｜啟動桃園黃金10年',
          excerpt: '經國特區位於北桃園交通門戶，結合國道、經國轉運站與捷運綠線G12站，從工業邊陲轉型為城市核心。南崁溪水岸升級、指標建商進駐，未來結合TOD開發與第二行政園區規劃，將成為桃園新CBD。',
          thumbnail: '/G121314.jpg'
        },
        {
          id: 23,
          slug: 'news-13',
          category: '新聞總覽',
          date: '2025.11.13',
          title: '桃園重大產業用地標售｜桃科二期 46,682 坪正式釋出',
          excerpt: '桃園科技工業園區第二期首波釋出46,682坪產業用地，位於北台灣科技走廊核心，採先租後售模式，企業僅需15%即可進駐，提供1.5年建照緩衝期及分期付款，投標截止至2025年1月13日。',
          thumbnail: '/news-13.jpg'
        },
        {
          id: 24,
          slug: 'news-14',
          category: '新聞總覽',
          date: '2025.11.06',
          title: '桃園建設大紀事｜國道2號「大竹交流道改善工程」正式動土',
          excerpt: '國道2號大竹交流道改善工程於11/3正式動土，總經費13.59億元，將新建高架匝道橋跨越中正東路，紓解匝道壅塞問題，縮短通勤時間，串聯桃園都會環線交通網。',
          thumbnail: '/news-14.jpg'
        },
        {
          id: 25,
          slug: 'news-15',
          category: '新聞總覽',
          date: '2025.11.03',
          title: '桃園航空城｜又一重大工程正式啟動招標！',
          excerpt: '桃園航空城計畫區段徵收工程（自貿港、崙仔後及A3周邊）於10/28正式招標，總經費33.16億元，涵蓋95公頃基地基礎工程，預計12/2開標，工期1,150天。',
          thumbnail: '/news-15.jpg'
        },
        {
          id: 10,
          slug: 'news-1',
          category: '新聞總覽',
          date: '2025.10.19',
          title: '結合航空城！桃園蘆竹誠聖段800戶社宅決標 2027年動工',
          excerpt: '蘆竹區誠聖段社宅預計提供近800戶，位於機場園區特定區，距機捷A11站僅600公尺。規劃一房型50%、二房型30%、三房型20%，整合托育中心與商業空間，預計2027年動工。',
          thumbnail: 'https://p1-news.hfcdn.com/p1-news/NzU1MzAyN25ld3M,/c5b3b4f9ddd24dde_1593x882.jpg/qs/w=1200&h=1200&r=16888'
        },
        {
          id: 11,
          slug: 'news-2',
          category: '新聞總覽',
          date: '2025.10.20',
          title: '航空城拆遷戶貸款卡關，是被信用管制措施害慘了？央行最新回應出爐',
          excerpt: '桃園航空城拆遷戶申請房貸遇困難，央行澄清信用管制措施並未針對自住需求，銀行應依個案審核。專家建議拆遷戶備妥財力證明，並多方比較貸款方案。',
          thumbnail: 'https://s.yimg.com/ny/api/res/1.2/eIzsxps3PqcbFQq1WF6L2w--/YXBwaWQ9aGlnaGxhbmRlcjt3PTk2MDtoPTU0MDtjZj13ZWJw/https://media.zenfs.com/en/stormmediagroup.com/858e0222285420d4256f74f3520a9173'
        },
        {
          id: 12,
          slug: 'news-3',
          category: '新聞總覽',
          date: '2025.02.25',
          title: '桃園航空城計畫重大進度曝！「先建後遷」期程出爐、不再展延',
          excerpt: '行政院強調「先建後遷」期程2026年底前完成不再展延。安置街廓已啟動點交，安置住宅陸續取得使用執照，配合第三跑道工程依計畫推進。',
          thumbnail: 'https://p1-news.hfcdn.com/p1-news/MzM2MzE4NG5ld3M,/67164d894eb9926c_934x437.jpg/qs/w=1200&h=1200&r=16888'
        },
        {
          id: 13,
          slug: 'news-4',
          category: '新聞總覽',
          date: '2024.09.06',
          title: '桃園捷運綠線G12站土地開發計畫啟動',
          excerpt: '桃園捷運綠線G12站周邊土地開發計畫正式啟動，預期將帶動中壢地區發展，提升區域房地產價值與生活機能。',
          thumbnail: 'https://hakkanews.tw/wp-content/uploads/2024/09/hakkanews.tw-2024-09-06_17-13-37_364238-jpg.webp'
        },
        {
          id: 14,
          slug: 'news-5',
          category: '新聞總覽',
          date: '2024.09.06',
          title: '桃園捷運綠線機廠工程進度超前',
          excerpt: '桃園捷運綠線機廠工程進度順利，預計2026年完工通車。機廠將提供列車維修與停放功能，是綠線營運的重要設施。',
          thumbnail: 'https://imgcdn.cna.com.tw/www/WebPhotos/1024/20240906/1151x768_wmkn_0_C20240906000095.jpg'
        },
        {
          id: 15,
          slug: 'news-6',
          category: '新聞總覽',
          date: '2024.09.05',
          title: '台鐵中路站周邊都市計畫啟動，124公頃土地開發',
          excerpt: '台鐵中路站周邊124公頃土地開發計畫正式啟動，將成為桃園重要發展區域，結合鐵路運輸與都市發展優勢。',
          thumbnail: 'https://p1-news.hfcdn.com/p1-news/MzQ4OTIzN25ld3M,/f1365e836e469fde_1250x938.jpg/qs/w=1200&h=1200&r=16888'
        },
        {
          id: 17,
          slug: 'news-7',
          category: '新聞總覽',
          date: '2025.01.06',
          title: '桃園都市更新獎勵加碼，防災型重建最高獎勵容積50%',
          excerpt: '桃園市府修正都市計畫法施行細則，提高防災型都更重建獎勵容積至最高50%，加速舊城再生，並新增可負擔住宅法源依據。',
          thumbnail: 'https://urbanrenewal.wealth.com.tw/uploads/editor/1757645926.png'
        },
        {
          id: 18,
          slug: 'news-8',
          category: '新聞總覽',
          date: '2024.08.20',
          title: '桃園小檜溪重劃區房價飆漲，吸引首購族進駐',
          excerpt: '小檜溪重劃區因交通便利、生活機能完善，房價持續上漲，吸引大量首購族進駐，成為桃園新興熱門區域。',
          thumbnail: 'https://p1-news.hfcdn.com/p1-news/NzI5NzQzMm5ld3M,/a57a3b9a71924c94_450x337.jpg'
        },
        {
          id: 19,
          slug: 'news-9',
          category: '新聞總覽',
          date: '2024.10.20',
          title: '桃園捷運綠線3站要開發！近千人湧入TOD說明會',
          excerpt: '桃園捷運綠線G07、G08、G09三站TOD開發說明會吸引近千位民眾參與，顯示當地居民高度關注，預期將帶動周邊房市發展。',
          thumbnail: 'https://s.yimg.com/ny/api/res/1.2/WgFRMMkYAaenDP0gaPTy.Q--/YXBwaWQ9aGlnaGxhbmRlcjt3PTk2MDtoPTcyMDtjZj13ZWJw/https://media.zenfs.com/ko/chinatimes.com.tw/386024570aa153ff1b8450333b64cf16'
        }
      ],
      // 洽詢表單
      formData: {
        name: '',
        nickname: '',
        phone: '',
        email: '',
        inquiryType: '',
        location: '',
        message: '',
        preferredContact: '皆可',
        preferredTime: '',
        privacyAgree: false
      },
      submitted: false,
      isSubmitting: false,
      submitSuccess: false,
      submitError: ''
    }
  },
  computed: {
    localAreaImgStyle() {
      const idx = this.localAreaHover ?? 0;
      return {
        backgroundImage: `url(${this.localAreas[idx].img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        aspectRatio: '3/4',
        height: 'auto',
        minHeight: '400px',
        maxHeight: '900px',
        position: 'relative',
        transition: 'background-image 0.5s cubic-bezier(.4,2,.6,1)'
      }
    },
    filteredArticles() {
      let filtered = [];
      if (this.activeTab === 'all') {
        filtered = this.articles;
      } else if (this.activeTab === 'knowledge') {
        filtered = this.articles.filter(article => article.category === '知識百科');
      } else if (this.activeTab === 'news') {
        filtered = this.articles.filter(article => article.category === '新聞總覽');
      } else {
        filtered = this.articles;
      }
      // 按日期排序（最新的在前面）
      filtered = filtered.slice().sort((a, b) => {
        const toNum = (d) => Number((d || '').split('.').join('')) || 0; // 2024.05.06 -> 20240506
        const an = toNum(a.date);
        const bn = toNum(b.date);
        return bn - an; // 降序排列，最新的在前
      });
      // 只顯示前6個
      return filtered.slice(0, 6);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    /* 防止瀏覽器恢復上次捲動位置，並在載入時回到頁面頂端 */
    if (typeof window !== 'undefined' && window.history && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
      this.$nextTick(() => setTimeout(() => window.scrollTo(0, 0), 0));
    }
    // 啟動在地深耕區域的自動輪播
    this.startAutoPlay();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.stopAutoPlay();
  },
  methods: {
    handleScroll() {
      this.isSticky = window.scrollY > 50;
    },
    startAutoPlay() {
      // 初始化為第一張圖片
      this.localAreaHover = 0;
      // 每5秒自動切換
      this.autoPlayTimer = setInterval(() => {
        if (!this.isUserHovering) {
          this.localAreaHover = (this.localAreaHover + 1) % this.localAreas.length;
        }
      }, 5000);
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    },
    handleMouseEnter(idx) {
      this.isUserHovering = true;
      this.localAreaHover = idx;
    },
    handleMouseLeave() {
      this.isUserHovering = false;
      // 不設置為 null，讓自動輪播繼續從當前位置
    },
    goToArea(link) {
      window.open(link, '_blank');
    },
    getTitleOverlayStyle(idx) {
      return {
        left: `${(idx/3)*100}%`,
        width: '33.3333%',
        height: '100%',
        position: 'absolute',
        top: 0,
        bottom: 'auto',
        color: this.localAreaHover===idx ? '#fff' : '#222',
        transition: 'background 0.4s, color 0.4s',
        borderRight: idx<2 ? '2px solid #fff' : 'none',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        zIndex: 2
      }
    },
    async handleSubmit() {
      this.submitted = true;
      this.submitSuccess = false;
      this.submitError = '';
      
      // 驗證必填欄位
      if (!this.formData.name || !this.formData.phone || !this.formData.email || 
          !this.formData.inquiryType || !this.formData.message || !this.formData.privacyAgree) {
        this.submitError = '請填寫所有必填欄位';
        return;
      }
      
      this.isSubmitting = true;
      
      try {
        // 準備要送出的資料，加上時間戳記
        const submitData = {
          ...this.formData,
          timestamp: new Date().toLocaleString('zh-TW', { 
            timeZone: 'Asia/Taipei',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
          })
        };
        
        // 提交到 Google Apps Script
        const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbwaAnYDf6bDYOQw9WuBkXmHBo9Whevx1b9iadrnQpGwnp0g7Sr4xUIHg-cSs5PGAzns/exec';
        
        // 如果還沒設定 Google Apps Script，暫時模擬成功
        if (SCRIPT_URL === 'YOUR_GOOGLE_APPS_SCRIPT_URL_HERE') {
          // 模擬 API 呼叫延遲
          await new Promise(resolve => setTimeout(resolve, 1500));
          console.log('表單資料（尚未連接 Google 試算表）:', submitData);
          this.submitSuccess = true;
          this.resetForm();
        } else {
          // 實際提交到 Google Apps Script
          await fetch(SCRIPT_URL, {
            method: 'POST',
            mode: 'no-cors',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(submitData)
          });
          
          this.submitSuccess = true;
          this.resetForm();
        }
      } catch (error) {
        console.error('提交失敗:', error);
        this.submitError = '系統發生錯誤，請稍後再試';
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        nickname: '',
        phone: '',
        email: '',
        inquiryType: '',
        location: '',
        message: '',
        preferredContact: '皆可',
        preferredTime: '',
        privacyAgree: false
      };
      this.submitted = false;
    },
    goToLinksSection(hash) {
      // 跳轉到 links 分頁並滾動到對應區塊
      this.$router.push({ path: '/links', hash: hash }).then(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            const target = document.querySelector(hash);
            if (target) {
              const headerEl = document.querySelector('header');
              const headerHeight = headerEl ? headerEl.getBoundingClientRect().height : 0;
              const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
              window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
            }
          }, 100);
        });
      });
    }
  }
}
</script>

<style scoped>
/* header：主導覽列，固定於頁面頂部，含背景、陰影、透明度動畫 */
header {
  transition: background 0.3s, box-shadow 0.3s, opacity 0.3s;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
  background: transparent;
  opacity: 0.01;
  pointer-events: auto;
}
/* header.sticky, header.nav-hidden:hover：滑動或滑鼠移入時顯示白底與陰影 */
header.sticky,
header.nav-hidden:hover {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* 當選單開啟時，header始終顯示 */
header:not(.nav-hidden) {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  opacity: 1;
}
/* logo-link：LOGO區塊，水平置中 */
.logo-link {
  display: flex;
  align-items: center;
  margin-right: 0;
}
/* logo-img：LOGO圖片，高度固定 */
.logo-img {
  height: 48px;
  width: auto;
  margin-left: 0;
  transition: height 0.25s ease;
}
/* nav：導覽列容器，靠右排列 */
nav {
  margin-left: auto;
}
/* nav .nav-link：導覽連結，字色與粗體 */
nav .nav-link {
  color: #333;
  font-weight: 500;
  transition: font-size 0.25s ease, padding 0.25s ease, color 0.2s ease;
}
/* nav .nav-link:hover：滑鼠移入時變色 */
nav .nav-link:hover {
  color: #007bff;
}

/* dropdown：滑鼠移入主選單時顯示下拉子選單 */
.dropdown {
  position: relative;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: #fff;               /* 固定白底，與上方選單一致 */
  box-shadow: none;               /* 無陰影/描邊 */
  border-radius: 0;               /* 無圓角 */
  border: none;                   /* 無邊框 */
  padding: 8px 0;
  min-width: 160px;
  display: block;                /* 常駐，讓動畫可運作 */
  opacity: 0;
  visibility: hidden;
  pointer-events: none;          /* 隱藏時不接收事件 */
  transform: translateY(10px) scaleY(0.98);
  transform-origin: top;
  transition: opacity 0.25s cubic-bezier(.2,.7,.2,1),
              transform 0.25s cubic-bezier(.2,.7,.2,1),
              visibility 0.25s cubic-bezier(.2,.7,.2,1);
  z-index: 10002;
}
.dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;         /* 顯示時可互動 */
  transform: translateY(0) scaleY(1);
}
.dropdown-item {
  display: block;
  padding: 8px 16px;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
}
.dropdown-item:hover {
  background: rgba(0,0,0,0.04);
  color: #007bff;
}

/* 調整導覽列間距，為漢堡按鈕騰出空間 */
.nav-with-hamburger {
  margin-right: 0;
}

/* 確保header容器有足夠空間顯示漢堡按鈕 */
.header-container {
  padding-right: 20px !important;
  min-height: 72px; /* 固定 header 高度，避免選單隱藏時視覺縮掉 */
  transition: min-height 0.25s ease, padding 0.25s ease;
}

/* about-section：關於長發區塊，最小高度設定 */
.about-section {
  margin-top: 0;
  padding-right: 0 !important;
  padding-bottom: 3rem;
}
/* about-row：關於長發左右 1:4 等比佈局（桌機），行動裝置改為單欄堆疊 */
.about-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: start;
  column-gap: 0;
}
/* about-title-col：左側標題欄，垂直置中 */
.about-title-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
  min-height: 100%;
}
/* about-title-vertical：直書大標題，字型加粗 */
.about-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #222;
  text-align: center;
  line-height: 1.1;
  margin-top: 6rem !important;
}
/* about-img-col：右側圖片欄，靠右對齊 */
.about-img-col {
    display: flex; /* 讓裡面的內容用 flex 排版 */
    flex-direction: column; /* 內容垂直排列 */
    align-items: flex-start; /* 水平對齊到左邊（靠左） */
    justify-content: flex-start; /* 垂直靠上（從上方開始排） */
    padding-top: 0; /* 移除上邊距 */
    padding-right: 0 !important; /* 移除右邊距，並強制覆蓋 Bootstrap 預設 */
}
/* about-img：關於圖片，滿版欄寬，依比例縮放 */
.about-img {
        width: 100%;
  height: auto;
        max-width: 100%;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  border-radius: 0;
  margin-right: 0;
}
/* about-desc：關於描述文字，置中 */
.about-desc {
  font-size: 1.15rem;
  color: #333;
  text-align: center;
}
.about-desc-align {
  text-align: left;
  margin-top: 1.5rem;
  font-size: 1.15rem;
  color: #333;
  width: 100%;
  margin-right: 0;
  padding-right: 2rem;
}
/* local-area-img-wrap：在地深耕圖片外層，置中 */
.local-area-img-wrap {
  position: relative;
  width: 100%;
  max-width: 100%;
  margin: 0 auto 0 auto;
}
/* local-area-img：主圖片區，含背景圖、RWD、動畫 */
.local-area-img {
  width: 100%;
  aspect-ratio: 3/4;
  min-height: 400px;
  max-height: 900px;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  transition: background-image 0.5s cubic-bezier(.4,2,.6,1);
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
/* 羽化遮罩效果 */
.local-area-img::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  pointer-events: none;
  z-index: 2;
  background: linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.0) 100%);
}
/* local-area-titles-overlay：標題覆蓋層，絕對定位 */
.local-area-titles-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  display: block;
  z-index: 9;
}
/* local-area-title-overlay：每個地區標題區，滑鼠互動動畫 */
.local-area-title-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.4s, color 0.4s;
  user-select: none;
}
.overlay-mask {
    position: absolute;
    top: 0;
    left: 0;
    height: 15%;
    min-height: 70px; /* 最小高度確保桌面版文字完整顯示 */
    width: 100%;
    background: rgba(0, 0, 0, 0.85);
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none; /* ⬅️ 保持 hover 由外層處理 */
    transition: background 0.4s;
}

.local-area-title-overlay:not(.active) .overlay-mask {
    background: rgba(255, 255, 255, 0.15);
    color: #222;
}
/* local-area-title-text：地區名稱，粗體、動畫 */
.local-area-title-text {
  font-size: clamp(1rem, 1.8vw, 1.6rem); /* 自適應字體，縮小最小值以顯示所有文字 */
  font-weight: 700;
  background: transparent;
  padding: 6px 10px 0 10px;
  border-radius: 0;
  transition: background 0.4s, color 0.4s;
  letter-spacing: 0.3px;
  /* 自動換行，顯示所有文字，最多兩行 */
  line-height: 1.25;
  max-height: 2.6em; /* 兩行高度 (1.25 × 2 + 少許留白) */
  overflow: visible; /* 顯示所有內容 */
  word-break: break-word; /* 允許長單詞換行 */
  display: block;
  hyphens: auto; /* 自動斷詞 */
}

/* 捷運綠線標題 - 獨立設定字體大小 */
.local-area-title-text.metro-green-title {
  font-size: clamp(1rem, 1.6vw, 1.6rem); /* 可手動調整此數值 */
}
/* local-area-desc：地區描述，次標題 */
.local-area-desc {
  font-size: clamp(0.75rem, 1.3vw, 0.95rem); /* 自適應字體，縮小以顯示所有文字 */
  font-weight: 400;
  margin-top: 3px;
  padding: 0 10px;
  line-height: 1.15;
  /* 顯示所有文字，不使用省略號 */
  overflow: visible;
  word-break: break-word;
}
/* more-info-box：右下角大黑格，緊貼右下角，無 padding */
.more-info-box {
  position: absolute;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.85);
  color: #fff;
  border-radius: 8px 0 0 0;
  /* 無 padding，改用固定寬高 */
  width: 120px;
  height: 48px;
  font-size: 1.15rem;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  cursor: pointer;
  z-index: 3;
  transition: background 0.3s;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* more-info-text：了解更多文字，hover 時往右滑動動畫 */
.more-info-text {
  display: inline-block;
  transition: transform 0.3s cubic-bezier(.4,2,.6,1);
}
.more-info-box:hover .more-info-text {
  transform: translateX(10px);
}
.logo-bar {
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  position: relative;
  z-index: 11;
  margin-top: -60px; /* 視覺上貼近 header */
  margin-bottom: 0;
}
.logo-bar .logo-link {
  display: flex;
  align-items: center;
}
.logo-bar .logo-img {
  height: 48px;
  width: auto;
}
.logo-bar-fixed {
  position: fixed;
  top: 16px;
  left: 32px;
  z-index: 10002;
  background: transparent;
  display: flex;
  align-items: center;
  transition: top 0.25s ease, left 0.25s ease;
}
.logo-bar-fixed .logo-link {
  display: flex;
  align-items: center;
}
.hamburger-bar-fixed {
  position: fixed;
  top: 16px;
  right: 20px;
  z-index: 10003; /* 高於 header 與 LOGO */
  display: block; /* 永遠顯示 */
}
.logo-bar-fixed .logo-img {
  height: 48px;
  width: auto;
  transition: height 0.25s ease;
}
.about-img-wrap {
  position: relative;
  display: block;
  width: 100%;
  margin-right: 0;
  /* 貼齊 container 右邊 */
  padding-right: 0 !important;
}
.about-img-btns {
  position: absolute;
  left: 16px;
  bottom: 16px;
  display: flex;
  gap: 8px;
}
.about-img-btn {
  width: 28px;
  height: 28px;
  border: none;
  outline: none;
  border-radius: 6px;
  background: #ccc;
  opacity: 0.7;
  cursor: pointer;
  transition: border 0.2s, opacity 0.2s;
}
.about-img-btn.black {
  background: #111;
}
.about-img-btn.gray {
  background: #888;
}
.about-img-btn.active {
  border: 2px solid #007bff;
  opacity: 1;
}
/* 漢堡選單按鈕樣式 */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 60px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  box-sizing: border-box;
  z-index: 10000;
  position: relative;
  margin-left: 30px;
  transition: width 0.25s ease, height 0.25s ease, margin-left 0.25s ease, transform 0.15s ease;
}

/* 確保漢堡按鈕在布幕選單開啟時仍然可見 */
.hamburger-btn.active {
  z-index: 10001 !important;
}

/* 確保整個導覽列在布幕選單之上 */
header {
  z-index: 10001 !important;
}

/* 在布幕選單開啟時隱藏其他導覽按鈕 */
.nav-link-item.hidden {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

/* 布幕選單開啟時將header背景變為透明 */
header.menu-header-transparent {
  background: transparent !important;
  box-shadow: none !important;
}

.hamburger-line {
  display: block;
  width: 100%;
  height: 2px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
  transform-origin: center;
}

/* 確保在布幕選單開啟時線條顏色更明顯 */
.hamburger-btn.active .hamburger-line {
  background: #333;
}

.hamburger-btn.active .hamburger-line:nth-child(1) {
  transform: translateY(13px) rotate(20deg);
  transform-origin: center;
}

.hamburger-btn.active .hamburger-line:nth-child(2) {  
  opacity: 0;
}

.hamburger-btn.active .hamburger-line:nth-child(3) {
  transform: translateY(-13px) rotate(-20deg);
  transform-origin: center;
}

/* 全螢幕選單彈出視窗樣式 - 布幕效果 */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.menu-overlay.active {
  opacity: 1;
  visibility: visible;
}

.menu-content {
  background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  transform: translateY(-100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(5px);
}

.menu-overlay.active .menu-content {
  transform: translateY(0);
}

.menu-header {
  display: flex;
  justify-content: flex-end;
  padding: 30px 40px;
  border-bottom: 1px solid #eee;
  min-height: 80px; /* 為漢堡按鈕預留空間 */
}

/* 移除關閉按鈕樣式，使用漢堡按鈕作為關閉按鈕 */

.menu-sections {
  padding: 50px 40px 40px 40px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.menu-buttons-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 120px;
  margin-bottom: 40px;
}

.menu-category {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.menu-category-title {
  font-size: 1.4rem;
  font-weight: 600;
  color: #000;
  margin-bottom: 25px;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.8);
}

.menu-category-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
}

.menu-category-item {
  font-size: 1rem;
  color: #000;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s ease;
  text-shadow: 0 0 3px rgba(255, 255, 255, 0.6);
}

.menu-category-item:hover {
  color: #007bff;
  transform: translateX(5px);
}

.menu-divider {
  height: 3px;           /* 黑線高度 */
  background: #000;      /* 黑線顏色 */
  margin: 0 auto;        /* 移除上下邊距，只保留左右自動置中 */
  width: 90%;            /* 寬度為視窗的90% */
  max-width: 1600px;     /* 最大寬度 */
}

.contact-info {
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 90%;
  max-width: 1600px;
  margin: 0 auto;
  flex-wrap: nowrap;
}

.contact-item {
  font-size: 1.1rem;
  color: #000;
  font-weight: 500;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.6);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.contact-item:first-child {
  text-align: left;
}

.contact-item:nth-child(2) {
  text-align: center;
}

.contact-item:nth-child(3) {
  text-align: center;
}

.contact-item:last-child {
  text-align: right;
}

@media (max-width: 880px) {
  /* 隱藏五個導覽連結（關於長發 ~ 聯絡我們） */
  .nav-link-item { display: none !important; }
  /* 避免縮小版出現兩個漢堡：隱藏 header 內的漢堡，僅保留獨立漢堡 */
  header .hamburger-btn { display: none !important; }
}

@media (max-width: 720px) {
  /* 縮小左上 LOGO 尺寸與位置 */
  .logo-bar-fixed {
    top: 12px;
    left: 16px;
  }
  .logo-bar-fixed .logo-img,
  .logo-img,
  .logo-bar .logo-img {
    height: 36px;
  }

  /* 縮小漢堡選單按鈕與導覽字級 */
  .hamburger-btn {
    width: 48px;
    height: 32px;
    margin-left: 16px;
    transition: transform 0.15s ease; /* 按下縮放動畫 */
  }
  .hamburger-bar-fixed { top: 12px; right: 12px; }
  /* 只針對獨立漢堡設定更明顯的按下與開啟動畫 */
  .hamburger-bar-fixed .hamburger-btn:active {
    transform: scale(0.94);
  }
  .hamburger-bar-fixed .hamburger-line {
    transition: transform 0.25s cubic-bezier(.2,.7,.2,1),
                width 0.2s ease,
                background 0.2s ease,
                opacity 0.2s ease;
  }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(1) {
    transform: translateY(11px) rotate(25deg);
    width: 100%;
  }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(2) {
    opacity: 0;
  }
  .hamburger-bar-fixed .hamburger-btn.active .hamburger-line:nth-child(3) {
    transform: translateY(-11px) rotate(-25deg);
    width: 100%;
  }
  nav .nav-link {
    font-size: 0.95rem;
    padding: 0.25rem 0.5rem;
  }
  .header-container {
    padding-right: 12px !important;
    min-height: 56px; /* ← 縮小版 UI 的 header 高度在這裡調整 */
  }

}

/* 地產小學堂樣式 - 新版左右分欄 */
.lesson-section-new {
  background: #fff;
  min-height: 600px;
}

.lesson-row {
  display: grid;
  grid-template-columns: auto 1fr;
  min-height: 400px;
  column-gap: 0;
}

.lesson-title-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: #fff;
  padding: 6rem 10rem;
  min-height: 100%;
}

.lesson-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  letter-spacing: 0.3rem;
  white-space: nowrap;
}

.lesson-content-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6rem 4rem;
  background: #fff;
}

.lesson-container-new {
  width: 100%;
  max-width: 1400px;
}

.lesson-tabs {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  flex-wrap: wrap;
}

.lesson-tab-btn {
  padding: 0.75rem 2rem;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 50px;
  color: #666;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lesson-tab-btn:hover {
  background: #e9ecef;
  border-color: #007bff;
  color: #007bff;
}

.lesson-tab-btn.active {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border-color: #007bff;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}

.lesson-articles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.lesson-article-card {
  background: white;
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  height: 380px;
}

.lesson-article-card:hover {
  border-color: #007bff;
  box-shadow: 0 8px 20px rgba(0, 123, 255, 0.15);
  transform: translateY(-5px);
  text-decoration: none;
}

.lesson-article-card .article-title {
  color: #333;
}

.lesson-article-card:hover .article-title {
  color: #007bff;
}

.article-thumbnail {
  width: 100%;
  padding-top: 56.25%; /* 16:9 比例 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
}

.article-content {
  display: flex;
  flex-direction: column;
  padding: 1.25rem;
  flex: 1;
  position: relative;
}

.article-date {
  color: #999;
  font-size: 0.85rem;
  position: absolute;
  bottom: 1.25rem;
  right: 1.25rem;
  margin: 0;
}

.article-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.75rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-excerpt {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
  margin: 0 0 2.5rem 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-more-articles {
  padding: 1rem 3rem;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.3);
}

.btn-more-articles:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

/* 相關連結樣式 - 新版 */
.links-section-new {
  margin-top: 0;
  padding-right: 0 !important;
  padding-bottom: 3rem;
  background: #fff;
}

.links-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: start;
  column-gap: 0;
}

.links-title-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
  min-height: 100%;
  order: 2;
}

.links-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #222;
  text-align: center;
  line-height: 1.1;
  margin-top: 6rem !important;
}

.links-img-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 0;
  padding-right: 0 !important;
  padding-left: 10rem;
  order: 1;
}

.links-images-container {
  width: 85%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.link-image-item {
  position: relative;
  width: 100%;
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;
}

.link-image-wrapper {
  position: relative;
  width: 100%;
  aspect-ratio: 3/4;
  overflow: hidden;
}

.link-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.link-image-item:hover .link-image {
  transform: scale(1.1);
  filter: brightness(0.6);
}

.link-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 1.5rem 1rem;
  pointer-events: none;
}

.link-overlay-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: 0.1em;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
  z-index: 2;
  transition: transform 0.3s ease;
}

.link-image-item:hover .link-overlay-title {
  transform: scale(1.05);
}

/* 響應式設計 */
@media (max-width: 768px) {
  .links-row {
    grid-template-columns: 1fr;
  }
  
  .links-title-col {
    order: 1;
    padding: 2rem 0;
  }
  
  .links-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 2rem;
    margin-top: 0 !important;
  }
  
  .links-img-col {
    order: 2;
    padding-left: 1rem;
    padding-right: 1rem;
  }
  
  .links-images-container {
    grid-template-columns: 1fr;
    width: 100%;
    gap: 1rem;
  }
  
  .link-overlay-title {
    font-size: 1.5rem;
  }
}

/* 洽詢表單樣式 - 新版 */
.inquiry-section-new {
  margin-top: 0;
  padding-right: 0 !important;
  padding-bottom: 3rem;
  padding-top: 3rem;
  background: #fff;
}

.inquiry-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: start;
  column-gap: 0;
}

.inquiry-title-col {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10px;
  min-height: 100%;
}

.inquiry-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #222;
  text-align: center;
  line-height: 1.1;
  margin-top: 6rem !important;
}

.inquiry-form-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 0;
  padding-right: 10rem !important;
  padding-left: 0 !important;
}

.form-container-new {
  width: 100%;
  background: white;
  padding: 2rem 0;
}

.form-subtitle-new {
  text-align: left;
  color: #666;
  font-size: 1.1rem;
}

.form-section {
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 2px solid #f0f0f0;
}

/* 為 fieldset 添加相同樣式 */
fieldset.form-section {
  border: none;
  border-bottom: 2px solid #f0f0f0;
  padding: 0;
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
}

.form-section:last-of-type,
fieldset.form-section:last-of-type {
  border-bottom: none;
}

.section-title-form {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  padding-left: 1rem;
  border-left: 4px solid #007bff;
}

/* 為 legend 添加相同樣式 */
legend.section-title-form {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  padding-left: 1rem;
  border-left: 4px solid #007bff;
  width: auto;
  float: none;
}

.contact-form-home .form-label {
  font-weight: 500;
  color: #333;
  margin-bottom: 0.5rem;
}

.required {
  color: #dc3545;
  font-weight: bold;
}

.contact-form-home .form-control,
.contact-form-home .form-select {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.contact-form-home .form-control:focus,
.contact-form-home .form-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,0.15);
}

.contact-form-home .form-control.is-invalid,
.contact-form-home .form-select.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: none;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.contact-form-home .form-control.is-invalid ~ .invalid-feedback,
.contact-form-home .form-select.is-invalid ~ .invalid-feedback,
.contact-form-home .form-check-input.is-invalid ~ .invalid-feedback {
  display: block;
}

.contact-form-home textarea.form-control {
  resize: vertical;
  min-height: 150px;
}

.contact-form-home .form-check {
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}

.contact-form-home .form-check-input {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.15rem;
  cursor: pointer;
}

.contact-form-home .form-check-label {
  cursor: pointer;
  color: #333;
  margin-left: 0.5rem;
}

.privacy-link {
  color: #007bff;
  text-decoration: underline;
}

.privacy-link:hover {
  color: #0056b3;
}

.btn-submit {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: white;
  padding: 1rem 3rem;
  font-size: 1.2rem;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,123,255,0.3);
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,123,255,0.4);
}

.btn-submit:active:not(:disabled) {
  transform: translateY(0);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-message {
  border-radius: 8px;
  animation: slideIn 0.5s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 公司資訊與地圖樣式 - 新版 */
.company-info-section-new {
  margin-top: 0;
  padding-right: 0 !important;
  padding-bottom: 0;
  padding-top: 0;
  background: #f8f9fa;
}

.company-info-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: stretch;
  column-gap: 2rem;
  min-height: 600px;
  padding: 0 3rem;
}

.company-info-title-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 3rem 0;
  background: #f8f9fa;
  order: 2;
}

.company-info-title-vertical {
  writing-mode: vertical-rl;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  color: #222;
  text-align: center;
  line-height: 1.1;
  margin-top: 0 !important;
  margin-bottom: 2rem;
}

.company-info-content {
  writing-mode: horizontal-tb;
  margin-top: 2rem;
  width: 100%;
}

.company-info-list-new {
  margin-bottom: 2rem;
}

.company-info-list-new li {
  padding: 0.75rem 0;
  color: #333;
  font-size: 1.1rem;
}

.company-info-list-new i {
  color: #007bff;
  font-size: 1.2rem;
}

/* Facebook 連結樣式 */
.facebook-link-container {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
}

.facebook-link {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #fff;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.facebook-link:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.facebook-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.facebook-text {
  color: #333;
  font-size: 1.1rem;
  font-weight: 500;
}

.facebook-link:hover .facebook-text {
  color: #1877f2;
}

.company-map-col {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
  order: 1;
  background: #f8f9fa;
  min-height: 600px;
}

.map-container-new {
  width: 100%;
  height: 600px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
}

.map-container-new iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 響應式設計 */
@media (max-width: 768px) {
  /* 關於長發區塊 */
  .about-row {
    grid-template-columns: 1fr;
  }
  
  .about-title-col {
    order: 1;
    padding: 2rem 0;
  }
  
  .about-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 1.1rem; /* 行動裝置縮小字體 */
    margin-top: 0 !important;
    letter-spacing: 0.15rem;
    padding: 0 1rem; /* 添加內距避免文字貼邊 */
  }
  
  .about-img-col {
    order: 2;
    padding-left: 1rem;
    padding-right: 1rem !important;
  }
  
  .about-desc-align {
    padding-right: 0;
    padding-left: 1rem;
  }
  
  /* 在地深耕區塊 */
  .local-area-img {
    min-height: 300px;
    max-height: 500px;
  }
  
  /* 在地深耕遮罩區塊 - 行動裝置調整高度 */
  .overlay-mask {
    height: 15%; /* 行動裝置增加高度以容納兩行文字 */
    min-height: 60px; /* 最小高度確保文字不會被裁切 */
  }
  
  /* 在地深耕標題文字 - 行動裝置自適應 */
  .local-area-title-text {
    font-size: clamp(0.7rem, 3.5vw, 1rem); /* 行動裝置縮小字體範圍，確保所有文字顯示 */
    letter-spacing: 0.2px;
    padding: 4px 8px 0 8px;
    line-height: 1.2;
    max-height: 2.5em; /* 行動裝置兩行高度 (1.2 × 2 + 少許留白) */
    overflow: visible; /* 確保所有文字都顯示 */
  }
  
  /* 捷運綠線標題 - 行動裝置獨立設定 */
  .local-area-title-text.metro-green-title {
    font-size: clamp(0.6rem, 3.2vw, 0.75rem); /* 行動裝置可手動調整此數值 */
  }
  
  /* 在地深耕描述文字 - 行動裝置自適應 */
  .local-area-desc {
    font-size: clamp(0.65rem, 2.8vw, 0.85rem); /* 行動裝置縮小字體，確保所有文字顯示 */
    margin-top: 2px;
    padding: 0 8px;
    line-height: 1.1;
    overflow: visible; /* 確保所有文字都顯示 */
  }
  
  /* 了解更多小黑格 - 行動裝置縮小 */
  .more-info-box {
    width: 100px; /* 行動裝置縮小寬度 */
    height: 40px; /* 行動裝置縮小高度 */
  }
  
  .more-info-text {
    font-size: 0.95rem; /* 行動裝置縮小字體 */
  }
  
  .local-area-title-single {
    font-size: 2rem;
    padding: 1rem;
  }
  
  /* 地產小學堂區塊 */
  .lesson-section-new {
    padding-top: 1rem; /* 縮小與在地深耕的距離 */
    padding-bottom: 1.5rem; /* 縮小底部空間 */
  }
  
  .lesson-row {
    grid-template-columns: 1fr;
    min-height: auto; /* 移除最小高度限制 */
  }
  
  .lesson-title-col {
    order: 1;
    padding: 1rem 0; /* 縮小上下 padding */
  }
  
  .lesson-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 2rem;
    margin-top: 0 !important;
    margin-bottom: 0; /* 移除底部邊距 */
    letter-spacing: 0.2rem;
  }
  
  .lesson-content-col {
    order: 2;
    padding: 0.5rem 0.5rem 0.5rem 0.5rem; /* 縮小上方 padding，保持下方空間 */
  }
  
  .lesson-articles {
    grid-template-columns: 1fr;
  }
  
  /* 地產小學堂按鈕 - 行動裝置縮小並置中對齊為一橫排 */
  .lesson-tabs {
    justify-content: center; /* 置中對齊 */
    gap: 0.75rem; /* 適中間距 */
    flex-wrap: nowrap; /* 不換行，保持一橫排 */
    overflow-x: auto; /* 如果太窄可以橫向滾動 */
    padding: 0 0.5rem; /* 左右留白 */
    margin-bottom: 1.5rem !important; /* 縮小與下方文章的距離，覆蓋 mb-4 */
  }
  
  .lesson-tab-btn {
    padding: 0.65rem 1.5rem; /* 比桌面版稍小，但不會太小 */
    font-size: 0.95rem; /* 比桌面版稍小，但保持易讀性 */
    white-space: nowrap; /* 文字不換行 */
    flex-shrink: 0; /* 防止按鈕被壓縮 */
  }
  
  .inquiry-row {
    grid-template-columns: 1fr;
  }
  
  .inquiry-title-col {
    order: 1;
    padding: 2rem 0;
  }
  
  .inquiry-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 2rem;
    margin-top: 0 !important;
  }
  
  .inquiry-form-col {
    order: 2;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  
  .form-container-new {
    padding: 1rem 0;
  }
  
  .section-title-form {
    font-size: 1.3rem;
  }
  
  .btn-submit,
  .btn-more-articles {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }
  
  .company-info-row {
    grid-template-columns: 1fr;
    min-height: auto;
    column-gap: 0;
    padding: 0 1rem;
  }
  
  .company-info-title-col {
    order: 1;
    padding: 2rem 0;
  }
  
  .company-info-title-vertical {
    writing-mode: horizontal-tb;
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
  
  .company-info-content {
    writing-mode: horizontal-tb;
    margin-top: 0;
  }
  
  .company-map-col {
    order: 2;
    min-height: 400px;
    padding: 2rem 0;
  }
  
  .map-container-new {
    height: 400px;
  }
}

/* 超小螢幕優化 - 稍微縮小按鈕 */
@media (max-width: 480px) {
  .lesson-tabs {
    gap: 0.6rem; /* 適中的間距 */
  }
  
  .lesson-tab-btn {
    padding: 0.55rem 1.2rem; /* 比一般行動裝置稍小 */
    font-size: 0.9rem; /* 保持可讀性 */
    border-width: 1.5px; /* 稍微細一點的邊框 */
  }
}

/* 行動裝置上橫向滾動條樣式優化 */
@media (max-width: 768px) {
  .lesson-tabs::-webkit-scrollbar {
    height: 4px; /* 滾動條高度 */
  }
  
  .lesson-tabs::-webkit-scrollbar-track {
    background: transparent; /* 軌道透明 */
  }
  
  .lesson-tabs::-webkit-scrollbar-thumb {
    background: rgba(0, 123, 255, 0.3); /* 滾動條顏色 */
    border-radius: 2px;
  }
  
  .lesson-tabs::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 123, 255, 0.5); /* hover 時顏色加深 */
  }
}
</style>
<style>
.main-root {
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
}
html, body {
  overflow-x: hidden !important;
  width: 100% !important;
}
</style> 